import React, { useEffect, useState } from 'react';
import { Modal, Row, Form, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Loader from '../../Components/Utility/Loader/Loader';
import { fetchSecurityQuestions, changeSecurityQuestions } from '../Auth/store/Auth.action';

function SetSecurityQuestionsModel({ show, toggle, title }) {
  const { t } = useTranslation('common');
  const QuestionList = [
    t('SECURITY_QUESTION.QUESTION_1'),
    t('SECURITY_QUESTION.QUESTION_2'),
    t('SECURITY_QUESTION.QUESTION_3'),
    t('SECURITY_QUESTION.QUESTION_4'),
    t('SECURITY_QUESTION.QUESTION_5'),
    t('SECURITY_QUESTION.QUESTION_6'),
    t('SECURITY_QUESTION.QUESTION_7'),
  ];

  const errMessage = t('SECURITY_QUESTION.ANSWER_REQUIRED');
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      questionOne: '',
      questionTwo: '',
      answerOne: '',
      answerTwo: '',
    },
  });

  const {
    UserDetails: {
      userInfo: { email },
      securityQuestion,
    },
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (!email) return;
    const fetch = async () => {
      setShowLoader(true);
      await dispatch(fetchSecurityQuestions({ email: encodeURIComponent(email), getAllQuestions: true }, t));
      setShowLoader(false);
    };
    fetch();
  }, [email, dispatch]);

  useEffect(() => {
    const keyWords = {
      ques0: 'questionOne',
      ques1: 'questionTwo',
      ans0: 'answerOne',
      ans1: 'answerTwo',
    };
    securityQuestion.forEach((obj, index) => {
      setValue(keyWords[`ques${index}`], obj.question);
      setValue(keyWords[`ans${index}`], obj.answer);
    });
  }, [securityQuestion, setValue]);

  const onSubmit = async (val) => {
    const reqObj = {
      questions: [
        {
          question: val.questionOne,
          answer: val.answerOne.trim(),
        },
        {
          question: val.questionTwo,
          answer: val.answerTwo.trim(),
        },
      ],
      email: encodeURIComponent(email),
    };
    setShowLoader(true);
    const res = await dispatch(changeSecurityQuestions(reqObj, t));
    setShowLoader(false);
    if (res) toggle();
  };

  const validate = (val) => {
    if (!val?.trim()) {
      return errMessage;
    }
    return null;
  };

  const checkIsSelected = (val) => {
    return val === watch('questionOne') || val === watch('questionTwo');
  };

  return (
    <Modal
      size="lg"
      show={show}
      toggle={toggle}
      backdrop="static"
      animation
      aria-labelledby="contained-modal-title-vcenter"
      className="common-custom-modal modal-medium"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header className="modal-header-custom">
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="confirm-title">{title}</span>
          </Modal.Title>
          <span type="button" aria-label="close" className="icon-close cursor-pointer ml-auto" onClick={toggle} />
        </Modal.Header>
        <Modal.Body>
          {showLoader ? (
            <Loader />
          ) : (
            <>
              <Row>
                <Col md={12} sm={12}>
                  <Form.Group className="common-input-control mb-0 pt-0">
                    <h2 className="f-16 mt-0 mb-0 font-heavy ">
                      {t('SECURITY_QUESTION.SECURITY_QUESTION_1')} <span className="required-star">*</span>
                    </h2>
                    <Form.Control
                      as="select"
                      {...register('questionOne', { required: t('SECURITY_QUESTION.PLEASE_SELECT_QUSTION') })}
                      className={watch('questionOne') && 'p-0 data-filled form-control '}
                    >
                      {QuestionList?.map((question) => {
                        return (
                          <option value={question} key={question} disabled={checkIsSelected(question)}>
                            {question}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {errors?.questionOne?.message && <Form.Text className="text-danger">{errors?.questionOne?.message}</Form.Text>}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={12} sm={12}>
                  <Form.Group className="common-input-control mb-0 pt-0">
                    <p className="f-16 mt-0 mb-0 font-heavy">Answer 1</p>
                    <Form.Control
                      {...register('answerOne', { required: errMessage, validate })}
                      className={watch('answerOne') && 'data-filled p-0 form-control '}
                    />
                    {errors?.answerOne?.message && <Form.Text className="text-danger">{errors?.answerOne?.message}</Form.Text>}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-16">
                <Col md={12} sm={12}>
                  <Form.Group className="common-input-control mb-0 pt-0">
                    <p className="f-16 mt-0 mb-0 font-heavy">
                      {t('SECURITY_QUESTION.SECURITY_QUESTION_2')} <span className="required-star">*</span>
                    </p>
                    <Form.Control
                      as="select"
                      {...register('questionTwo', { required: t('SECURITY_QUESTION.PLEASE_SELECT_QUSTION') })}
                      className={watch('questionTwo') && 'data-filled common-select p-0 form-control'}
                    >
                      {QuestionList?.map((question) => {
                        return (
                          <option value={question} key={question} disabled={checkIsSelected(question)}>
                            {question}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {errors?.questionTwo?.message && <Form.Text className="text-danger">{errors?.questionTwo?.message}</Form.Text>}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={12} sm={12}>
                  <Form.Group className="common-input-control mb-0 pt-0">
                    <p className="f-16 mt-0 mb-0 font-heavy">Answer 2</p>
                    <Form.Control
                      {...register('answerTwo', { required: errMessage, validate })}
                      className={watch('answerTwo') && 'data-filled p-0 form-control'}
                    />
                    {errors?.answerTwo?.message && <Form.Text className="text-danger">{errors?.answerTwo?.message}</Form.Text>}
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
          <div className="common-model-footer mt-16">
            <button type="submit" aria-label="tick" className="btn p-0 text-left">
              <i className="icon-Tick-1 f-24" />
            </button>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
}
export default SetSecurityQuestionsModel;
